import React, { Component } from 'react';
import _ from 'lodash'
import t from './translate/t'
import icons from './icons'
import partyNames from './data/parties'

function addRef(url) {
  let separator = '?'

  if (url.includes('?')) {
    separator = '&'
  }

  return url + separator + 'ref=pikavaalikone.fi'
}

export default props => {
  const { candidate, differentOpinions } = props
  const percentage = props.percentage || 0

  let title = _.truncate(candidate.title, { length: window.innerWidth <= 700 ? 40 : 100 })

  return <div className="card w-full mb-6 text-sm">
    <div className="flex flex-row">
      <div className="flex justify-center items-center text-lg font-bold candidate-number bg-primary-light select-text">{candidate.number}</div>
      <div className="flex-1 candidate-content">
        <div className="px-2 pt-1 relative">
          <div className="text-md overflow-hidden select-text">{candidate.firstName} {candidate.lastName} <span className="text-md text-dark">({Math.round(percentage * 100) + '%'})</span></div>
          <div className="candidate-card-right">
            {candidate.gender && t(`gender-${candidate.gender}`) + ' '}
            {candidate.age && <span>{candidate.age}{t('age')}</span>}
            </div>
        </div>
        <div className="px-2 relative">
          <div title={candidate.title}>{title}</div>
          <div className="candidate-card-right">{candidate.city}</div>
        </div>
        <div className="flex flex-row px-2 pb-1 bg-light">
          <div className="flex-1 overflow-hidden select-text">{partyNames[candidate.party] || candidate.party} {candidate.partyAlliance ? <span className="text-dark">({t('partyAlliance')}: {candidate.partyAlliance})</span> : ''}</div>
          <div className="flex flex-row justify-end -mx-1">
            {candidate.fb && <div className="icon-container mx-1"><a href={'https://www.facebook.com/' + candidate.fb} rel="noopener noreferrer nofollow" target="_blank"><span dangerouslySetInnerHTML={{ __html: icons.fb }} /></a></div>}
            {candidate.tw && <div className="icon-container mx-1"><a href={'https://www.twitter.com/' + candidate.tw} rel="noopener noreferrer nofollow" target="_blank"><span dangerouslySetInnerHTML={{ __html: icons.tw }} /></a></div>}
            {candidate.website && <div className="icon-container mx-1 font-bold"><a href={addRef(candidate.website)} rel="noopener noreferrer nofollow" target="_blank">www<span dangerouslySetInnerHTML={{ __html: icons.newtab }} /></a></div>}
          </div>
        </div>
      </div>
    </div>
    {differentOpinions.length ? <div className="pt-1 px-2">
      {differentOpinions.map(opinion => <div key={opinion} className="pb-1">{t('Different opinion')}: {t(opinion)}</div>)}
    </div> : null}
  </div>
}
